import { classes } from "common/theme/theme";
import { FieldValidator, useField } from "formik";
import { MuiErrorMessage } from "./MuiErrorMessage";
import { TextField, TextFieldProps, Tooltip, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import React, { FC } from "react";

interface FormikTextInputProps {
  label: string;
  name: string;
  validate?: boolean;
  validator?: FieldValidator;
  disabled?: boolean;
  tooltipText?: string;
  tProps?: { [key: string]: number | string };
  className?: string;
  textFieldProps?: TextFieldProps;
}
export const FormikTextInput: FC<FormikTextInputProps> = ({
  label,
  name,
  validate = true,
  validator,
  disabled,
  tooltipText,
  tProps,
  className,
  textFieldProps,
}) => {
  const [field, meta, helpers] = useField({
    name,
    validate: validator,
  });
  const { value } = meta;
  const { setTouched, setValue } = helpers;
  const { onBlur } = field;

  const errorMessage = <MuiErrorMessage name={name} tProps={tProps} />;

  return (
    <div className={classes("flex flex-col w-80", className)}>
      <div className="flex gap-1">
        <Typography>{label}</Typography>
        {tooltipText && (
          <Tooltip title={tooltipText}>
            <InfoOutlinedIcon />
          </Tooltip>
        )}
      </div>
      <TextField
        error={Boolean(meta.touched && meta.error)}
        disabled={disabled}
        size="small"
        value={value}
        onChange={(e) => {
          setTouched(true, validate);
          setValue(e.target.value);
        }}
        onBlur={onBlur}
        placeholder={label}
        helperText={errorMessage}
        {...textFieldProps}
      />
    </div>
  );
};
